import { bigDataHttp,wmsHttp,otmsHttp } from '@/utils/http/index.js'

/**
 * 库存查询(按可用量)
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/24795
 */

export function warehouseStockPage(data,params) {
	return otmsHttp.post('/warehouse/stock/page', data,{params})
}

/**
 * 库存查询(按批次)
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/24797
 */

 export function warehouseStockContainerBatchPage(data,params) {
	return otmsHttp.post('/warehouse/stock/container/batch/page', data,{params})
 }

 /**
 * 库存查询(按库位)
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/24799
 */

  export function warehouseStockBatchPage(data,params) {
    return otmsHttp.post('/warehouse/stock/batch/page', data,{params})
  }
   /**
 * 库存导出(按库位) 
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/24803
 */

export function warehouseStockBatchExport(data,params) {
  return otmsHttp.post('/data/export/stockBatchV2', data,{params})
}
  
/**
 * 临期预警库存列表
 */
export function willOverdueStock(data,params) {
	return bigDataHttp.post('/api/web/cust_board/near_overdue_stock', data,{params})
}

/**
 * 超期预警库存列表
 */
 export function overdueStock(data,params) {
	return bigDataHttp.post('/api/web/cust_board/overdue_stock', data,{params})
 }

/**
 * @description: 库区信息表 分页查询
 * @api文档：https://yapi.ops.yunlizhi.cn/project/388/interface/api/11164
 */
export function warehouseZonePage(params, data) {
  return wmsHttp.post('/warehouse_foundation/zone/page', data, {
    params,
  });
}

/**
 * @description: 数据字典接口
 * @api: https://yapi.ops.yunlizhi.cn/project/388/interface/api/11212
 */
 export function getDictionaryFromWms() {
  return wmsHttp.get('/warehouse_foundation/dictionary/get_dictionary_json');
 }

 /**
 * @description: 批次字段列表
 * @api文档：https://yapi.ops.yunlizhi.cn/project/385/interface/api/12622
 *
 */
export function batchFieldList(data) {
  return wmsHttp.post('/warehouse_management_system/batch_field/list', data, {});
}

/**
 * @description: 列表显示自定义字段接口(驼峰)
 * @api文档：https://yapi.ops.yunlizhi.cn/project/382/interface/api/20687
 *
 */
 export function customerShowList(data) {
  return wmsHttp.post('/warehouse_management_system/batch_field/customer/show/list', data, {});
 }

 /**
 * @description:库位批次库存分页查询
 * @api文档：https://yapi.ops.yunlizhi.cn/project/382/interface/api/15123
 */
export function shipperGoodsStockPage(data,params) {
  return wmsHttp.post('/warehouse_management_system/stock/batch_stock/page', data, {
    params,
  });
}

/**
 * @description: 解冻库存
 * @api文档：https://yapi.ops.yunlizhi.cn/project/382/interface/api/17525
 *
 */
 export function searchBatchStockLocked(data) {
  return wmsHttp.post('/warehouse_management_system/stock/batch_stock/locked/query', data, {});
}